import '../css/main.css';

import menuOpen from './menuOpen';
import injectSearch from './injectSearch';

injectSearch();
menuOpen();
